import { render, staticRenderFns } from "./KarteInfo.vue?vue&type=template&id=67ced7c2&"
import script from "./KarteInfo.vue?vue&type=script&lang=ts&"
export * from "./KarteInfo.vue?vue&type=script&lang=ts&"
import style0 from "./KarteInfo.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports